// Route metadata registry, one source of truth for titles/descriptions/OG images.
import { PHOTOS } from '@/constants/content';

export const SEO = {
  home: {
    title: 'Toia Wallace | Founder, Speaker, Author & AI Business Transformation Strategist',
    description:
      'The official Founder HQ of Toia Wallace, founder, speaker, author, software entrepreneur, and AI Business Transformation Strategist building companies, technology, and educational platforms for the next generation of entrepreneurs.',
    path: '/',
    image: PHOTOS.homeHero,
  },
  about: {
    title: 'About Toia Wallace | Founder, Speaker & Author',
    description:
      "Learn about Toia Wallace's journey, from entrepreneur to laboratory founder, speaker, author, and software entrepreneur building AI-powered platforms for the next generation of founders.",
    path: '/about',
    image: PHOTOS.about,
  },
  companies: {
    title: 'Companies | Toia Wallace',
    description:
      'Explore the growing ecosystem of companies founded by Toia Wallace, including LabFounders HQ, Altura Global RE, Move MODE, Between Us Convos, and future ventures.',
    path: '/companies',
    image: PHOTOS.companies,
  },
  speaking: {
    title: 'Speaking | Toia Wallace',
    description:
      'Book Toia Wallace for conferences, corporate events, universities, leadership summits, podcasts, and workshops focused on AI, entrepreneurship, business strategy, and innovation.',
    path: '/speaking',
    image: PHOTOS.speaking,
  },
  media: {
    title: 'Media | Toia Wallace',
    description:
      'Documentary, AI summit keynote, magazine features, published works, and educational courses, the public record of Toia Wallace, founder, speaker, author, software entrepreneur, and AI Business Transformation Strategist.',
    path: '/media',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_toia-ecosystem/artifacts/zz137mrc_Front%20Cover.webp',
  },
  resources: {
    title: 'Resources | Toia Wallace',
    description:
      'Explore business resources, founder insights, templates, AI tools, and educational content created by Toia Wallace.',
    path: '/resources',
    image: PHOTOS.editorial,
  },
  workWithMe: {
    title: 'Work With Me | Toia Wallace',
    description:
      'Explore opportunities to work with Toia Wallace through speaking engagements, Strategy Intensives, and strategic partnerships.',
    path: '/work-with-me',
    image: PHOTOS.work,
  },
  journal: {
    title: 'Founder Journal | Toia Wallace',
    description:
      'Behind-the-scenes reflections, founder lessons, company updates, AI insights, and entrepreneurship from the desk of Toia Wallace.',
    path: '/journal',
    image: PHOTOS.editorial,
  },
  now: {
    title: 'Now | Toia Wallace',
    description:
      'See what Toia Wallace is currently building, learning, launching, and focusing on as she grows her ecosystem of companies.',
    path: '/now',
    image: PHOTOS.lifestyle,
  },
  contact: {
    title: 'Contact | Toia Wallace',
    description:
      'Get in touch with Toia Wallace for speaking engagements, partnerships, media inquiries, or general questions.',
    path: '/contact',
    image: PHOTOS.contact,
  },
  partners: {
    title: 'Executive Portal | Toia Wallace',
    description: 'Private resource center for producers, event organizers, media, and strategic partners.',
    path: '/partners',
    image: PHOTOS.speaking,
    robots: 'noindex, nofollow',
  },
};

// Reusable JSON-LD builders
export const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Toia Wallace',
  jobTitle: 'Founder, Technology Entrepreneur, AI Business Transformation Strategist',
  url: 'https://iamtoiawallace.com',
  image: PHOTOS.homeHero,
  sameAs: ['https://www.linkedin.com', 'https://www.instagram.com', 'https://www.youtube.com'],
  worksFor: [
    { '@type': 'Organization', name: 'LabFounders HQ' },
    { '@type': 'Organization', name: 'Altura Global RE' },
    { '@type': 'Organization', name: 'Move MODE' },
    { '@type': 'Organization', name: 'Between Us Convos' },
  ],
};

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Toia Wallace, Founder HQ',
  url: 'https://iamtoiawallace.com',
  logo: 'https://customer-assets.emergentagent.com/job_86d138bb-490b-4c43-8779-6497c2705276/artifacts/6i8599pe_New%20logo%20transparent.png',
  founder: { '@type': 'Person', name: 'Toia Wallace' },
  sameAs: ['https://www.linkedin.com', 'https://www.instagram.com'],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Toia Wallace, Founder HQ',
  url: 'https://iamtoiawallace.com',
  publisher: { '@type': 'Person', name: 'Toia Wallace' },
};

export function breadcrumb(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: `https://iamtoiawallace.com${it.path}`,
    })),
  };
}

export function articleSchema(entry) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: entry.title,
    description: entry.dek,
    image: [PHOTOS.editorial],
    datePublished: entry.date,
    author: { '@type': 'Person', name: 'Toia Wallace' },
    publisher: { '@type': 'Organization', name: 'Toia Wallace, Founder HQ' },
    mainEntityOfPage: { '@type': 'WebPage', '@id': `https://iamtoiawallace.com/journal/${entry.slug}` },
  };
}
